<template>
  <div class="word">
    <video id="video" :src="url" controls preload="auto"    x5-playsinline="" playsinline="" webkit-playsinline="" ></video>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: "",
    };
  },
  mounted() {
    let url=this.$route.query.url
    if(!url)this.$router.go(-1)
    else this.url=url
    const video = document.querySelector("#video");
    video.requestFullscreen();

    video.webkitRequestFullscreen();

  },
};
</script>
<style lang="less" scoped>
.word {
  width: 100%;
  height: 100vh;
  background: #000;
  display: flex;
  align-items: center;
  .wh100 {
    width: 100%;
    height: 100vh;
  }
  video {
    width: 100%;
  }
}
</style>